import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pr_ic",
  "use": "pr_ic-usage",
  "viewBox": "0 0 17 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 22\" id=\"pr_ic\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M-4-2h25v25H-4z\" /><path fill=\"#3DCD58\" d=\"M0 0h10.973L17 6.063V22H0z\" /><path fill=\"#009530\" d=\"M11 0l6 6h-6z\" /><path d=\"M11.152 9.301L7.73 14.328l-1.928-2.17c-.232-.26-.681-.32-1.003-.131-.323.188-.395.553-.163.814l2.592 2.917c.308.347.957.315 1.212-.06l3.97-5.833c.192-.282.066-.636-.282-.792-.347-.156-.785-.054-.976.228z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol